<template src="./template.html"></template>
<style src="./styles.scss" lang="scss" scoped></style>
<style src="./activity-feed.scss" lang="scss"></style>

<script>
  import { mapState, mapActions } from 'vuex'
  import { filter } from 'lodash'
  import FallbackAvatar from '@/components/ui/FallbackAvatar'
  import OccasionsSlider from '@/components/modules/occasions/OccasionsSlider'
  import AppPagination from '@/components/ui/AppPagination'
  import GroupInvitationOverlay from '@/components/overlays/group/GroupInvitationOverlay'

  export default {
    name: 'ActivityFeedPage',
    components: {
      AppPagination,
      OccasionsSlider,
      GroupInvitationOverlay,
      FallbackAvatar,
    },
    metaInfo() {
      return {
        title: this.$t('meta.activity-feed.title'),
      }
    },
    data() {
      return {
        page: 1,
        invite: false,
        selectedGroup: {},
      }
    },
    computed: {
      ...mapState('activities', [
        'activities',
        'pagination',
        'unread_activities',
      ]),
      ...mapState('auth', ['settings']),
      getUnreadCountFromActivities() {
        // We need strict quality check here, cause only 'false' should count as unread (not everything not being true)
        return filter(this.activities, function(activity) { if (activity.read === false) return activity }).length
      },
    },
    watch: {
      '$route.query'(value) {
        this.page = value.page ? value.page : 1
        this.getActivities(this.page)
      },
      unread_activities(val) {
        if (val) {
          this.getActivities(this.page)
        }
      },
    },
    created() {
      this.page = this.$route.query.page || this.page
      this.getActivities(this.page)
    },
    destroyed() {
      this.getCountUnreadActivities()
    },
    methods: {
      ...mapActions('groups', [
        'acceptInvitation',
        'declineInvitation',
        'acceptRequest',
        'declineRequest',
      ]),
      ...mapActions('activities', [
        'getActivities',
        'getCountUnreadActivities',
      ]),
      ...mapActions('auth', ['getRoutes']),
      closeOverlay() {
        this.selectedGroup = {}
      },
      getIconClasses(icon) {
        const iconClass = this.iconMapping(icon)
        return iconClass.indexOf('mdi-') === 0 ? `mdi ${iconClass}` : iconClass
      },
      loadData() {
        this.getRoutes()
        this.getActivities(this.page)
      },
      onAcceptInvitation(id, type) {
        type === 'invite' ? this.acceptInvitation(id).then(_ => this.loadData()) : this.acceptRequest(id).then(_ => this.loadData())
      },
      onDeclineInvitation(id, type) {
        type === 'invite' ? this.declineInvitation(id).then(_ => this.loadData()) : this.declineRequest(id).then(_ => this.loadData())
      },
      getTranslationString(type) {
        const activityType = {
          comment: 'view_comment',
          chat_group: 'view_message',
          application_accepted: 'view_group',
          application_declined: 'view_profile',
        }
        const transActivityFeed = this.$t('activity_feed')
        return transActivityFeed[activityType[type] || 'view_post']
      },
    },
  }
</script>
